(function($, psw){

    'use strict';

    // == Configuration ===========

    // The sets of "You choose _____, we take care of ______" - make sure that each variable doesn't take more than one line on mobile.
    // Commas and periods will be added in
    var heroSets = [
        ["the messaging technology", "the messages"],
        ["the hosting", "keeping data intact"],
        ["the persistence", "data consistency"],
        ["the message serializer", "message delivery"],
        ["the business problem", "message orchestration"],
        ["a cloud or on-premises stack", "the plumbing"]
    ];
    var changeEveryMs = 3500;

    // == Implementation =============

    heroSets.forEach(function (set) {
        set[0] += ',';
        set[1] += '.';
    });

    $(function () {

        var $elements = [$('.you-choose'), $('.we-take')];
        var currentIndex = 0;

        function nextSet() {

            currentIndex = (currentIndex + 1) % heroSets.length;
            var next = heroSets[currentIndex];

            $elements.forEach(function ($el, i) {

                var nextText = next[i];
                $el.hide().text(nextText);

                setTimeout(function () {
                    $el.show();
                }, 100);
            });
        }

        setInterval(nextSet, changeEveryMs);
    });

}(jQuery, window.psw));